import { ReactNode } from 'react';
import { useLoaderData } from 'react-router-dom';

type PageSwitchProps<TData> = {
  render: (data: TData) => ReactNode;
};

/**
 * If possible, use `routeElementWithLoader` for better type-safety
 */
export function PageSwitch<TData>({ render }: PageSwitchProps<TData>) {
  const loaderData = useLoaderData() as TData;
  return render(loaderData);
}
